// Audits table extracted from AdminAudits.jsx (W2d). Verbatim DOM,
// row test-ids, and column layout.
import { Link } from "react-router-dom";

export default function AdminAuditsTable({ rows, loading }) {
  return (
    <div className="sf-card" style={{ padding: 0 }} data-testid="admin-audits-table">
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr style={{ textAlign: "left", color: "var(--sf-gold)", fontFamily: "var(--sf-mono)", fontSize: 11, letterSpacing: "0.08em" }}>
            <th style={{ padding: 10 }}>BUSINESS</th>
            <th style={{ padding: 10 }}>EMAIL</th>
            <th style={{ padding: 10 }}>STATUS</th>
            <th style={{ padding: 10 }}>PAID</th>
            <th style={{ padding: 10 }}>SCORE</th>
            <th style={{ padding: 10 }}>LOSS / MO</th>
            <th style={{ padding: 10 }}>CREATED</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr><td colSpan={7} style={{ padding: 16, color: "var(--sf-muted)" }}>Loading…</td></tr>
          )}
          {!loading && rows.length === 0 && (
            <tr><td colSpan={7} style={{ padding: 16, color: "var(--sf-muted)" }}>No audits match these filters.</td></tr>
          )}
          {!loading && rows.map((r) => (
            <tr key={r.session_id} style={{ borderTop: "1px solid #22262B" }} data-testid={`admin-audits-row-${r.session_id}`}>
              <td style={{ padding: 10 }}>
                <Link to={`/admin/audits/${r.session_id}`} style={{ color: "var(--sf-offwhite)" }}>
                  {r.business_name || <span className="sf-muted-text">(no name)</span>}
                </Link>
              </td>
              <td style={{ padding: 10 }} className="sf-mono">{r.email || "—"}</td>
              <td style={{ padding: 10 }}>{r.status}</td>
              <td style={{ padding: 10 }}>{r.paid ? "PAID" : "free"}</td>
              <td style={{ padding: 10 }} className="sf-mono">{r.revenue_leak_score ?? "—"}</td>
              <td style={{ padding: 10 }} className="sf-mono">
                {r.monthly_loss_midpoint ? `$${r.monthly_loss_midpoint.toLocaleString()}` : "—"}
              </td>
              <td style={{ padding: 10 }} className="sf-mono sf-muted-text" >{r.created_at}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
